import React from 'react';
import logo from '../../assets/DoveMed_NoShadow.png';
import { StyledContainer } from '../../Home/Home.styles';
import { redirectOutside } from '../../utilities';
import {
    FlexWrapper,
    StyledLink,
    Image,
    LinkOutside
} from './Footer.styles';

export function Footer() {
    return (
        <StyledContainer>
            <FlexWrapper>
                <div>
                    <Image src={logo} alt="DoveMed-Logo" />
                </div>
                <div>
                    <StyledLink to={`${process.env.REACT_APP_INTERNAL_URL}support`}>Support</StyledLink>
                    <LinkOutside onClick={() => redirectOutside('/')}>Guidelines</LinkOutside>
                    <LinkOutside onClick={() => redirectOutside('/privacy-policy/')}>Privacy policy</LinkOutside>
                    <LinkOutside onClick={() => redirectOutside('/about-us/terms-conditions/')}>Terms of use</LinkOutside>
                </div>
            </FlexWrapper>
        </StyledContainer>
    )
}
